import React, { useContext } from 'react';
import classNames from 'classnames';
import { DataRoomMember } from 'router/subrouters/DataRoom/models/DataRoomMember';
import LeadTimeActivity from 'router/subrouters/Dash/subrouters/private/subrouters/Portfolio/subrouters/Seller/subrouters/ListingDetailSeller/components/ManageLeadDrawer/components/LeadInformation/components/LeadTimeActivity';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { BUYERS_ACTIVITY_TRACK_TYPE } from 'models/Lead';
import { MEMBER_ACTIVITY_PAGE } from 'models/MixpanelEvents';
import useLeadStagesCopy from 'hooks/useLeadStagesCopy';
import { EVENT_TYPES_DATA_ROOM_FIRST } from 'router/subrouters/Dash/subrouters/private/subrouters/Portfolio/subrouters/Seller/subrouters/ListingDetailSeller/components/ManageLeadDrawer/components/LeadInformation/components/LeadTimeActivity/components/EventTypeFilters/data';

import './MemberActivity.styles.scss';

type MemberActivityProps = {
  className?: string;
  dataRoomId: string;
  dataRoomMember: DataRoomMember;
};

const MemberActivity: React.FC<MemberActivityProps> = (props) => {
  const {
    className,
    dataRoomMember: { leadId, firstName, lastName, email },
  } = props;

  const {
    dataRoom: { name, dealRoomId, dealRoom },
  } = useContext(DataRoomContext);

  const classes = classNames('member-activity', className);

  const leadStagesCopies = useLeadStagesCopy().getCopies(
    dealRoom?.leadStagesCopies,
  );

  return (
    <div className={classes}>
      <LeadTimeActivity
        lead={{ _id: leadId, firstName, lastName, email }}
        dealId={dealRoomId}
        dealName={name}
        initialSelectedEventTypes={[BUYERS_ACTIVITY_TRACK_TYPE.DATA_ROOM]}
        eventTypes={EVENT_TYPES_DATA_ROOM_FIRST}
        memberActivityPage={MEMBER_ACTIVITY_PAGE.MEMBERS_PAGE}
        leadStagesCopies={leadStagesCopies}
      />
    </div>
  );
};

export default MemberActivity;
